import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EditText from '../../../../components/base/edit-text/edit-text';
import Button from '../../../../components/base/button/button';
import i18n from '../../../../translations/strings';
import { EditProfileFormStyled } from './edit-profile-form-styled';
import { useSelector } from 'react-redux';

const EditProfileForm = (props: any) => {
  const { user } = useSelector((state: any) => {
    return state.user;
  });

  const {
    control,
    trigger,
    formState: { errors, submitCount },
    register,
    handleSubmit,
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (user) {
      setValue('phone_number', user.phone_number, { shouldValidate: true });
      setValue('vat_number', user.vat_number, { shouldValidate: true });
      setValue('tax_code', user.tax_code, { shouldValidate: true });
      setValue('business_name', user.business_name, { shouldValidate: true });
      setValue('business_address', user.business_address, {
        shouldValidate: true,
      });
      setValue('business_unique_code', user.business_unique_code, {
        shouldValidate: submitCount > 0 && true,
      });
      setValue('business_email', user.business_email, {
        shouldValidate: submitCount > 0 && true,
      });
    }
  }, [user]);

  const onFieldChangeValue = (onChange: any, value: any) => {
    onChange(value);
    if (submitCount > 0) {
      trigger();
    }
  };

  return (
    <EditProfileFormStyled.Container>
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.phone_number?.message?.toString()}
            fullWidth
            {...register('phone_number')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.phoneNumber') + '*'}
            onChange={onChange}
            label={i18n.t('editProfile.phoneNumber') + '*'}
          />
        )}
        name="phone_number"
      />
      <EditProfileFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.vat_number?.message?.toString()}
            fullWidth
            {...register('vat_number')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.vatNumber') + '*'}
            onChange={onChange}
            label={i18n.t('editProfile.vatNumber') + '*'}
          />
        )}
        name="vat_number"
      />
      <EditProfileFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.tax_code?.message?.toString()}
            fullWidth
            {...register('tax_code')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.taxCode') + '*'}
            onChange={onChange}
            label={i18n.t('editProfile.taxCode') + '*'}
          />
        )}
        name="tax_code"
      />
      <EditProfileFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_name?.message?.toString()}
            fullWidth
            {...register('business_name')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.businessName') + '*'}
            onChange={onChange}
            label={i18n.t('editProfile.businessName') + '*'}
          />
        )}
        name="business_name"
      />
      <EditProfileFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_address?.message?.toString()}
            fullWidth
            {...register('business_address')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.businessAddress') + '*'}
            onChange={onChange}
            label={i18n.t('editProfile.businessAddress') + '*'}
          />
        )}
        name="business_address"
      />
      <EditProfileFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_email?.message?.toString()}
            fullWidth
            {...register('business_email')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.businessEmail') + '*'}
            onChange={(value) => onFieldChangeValue(onChange, value)}
            label={i18n.t('registration.businessEmail') + '*'}
          />
        )}
        name="business_email"
      />
      <EditProfileFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.business_unique_code?.message?.toString()}
            fullWidth
            {...register('business_unique_code')}
            defaultValue={value}
            placeholder={i18n.t('editProfile.businessUniqueCode') + '*'}
            onChange={(value) => onFieldChangeValue(onChange, value)}
            label={i18n.t('editProfile.businessUniqueCode') + '*'}
          />
        )}
        name="business_unique_code"
      />
      <EditProfileFormStyled.Separator />
      <EditProfileFormStyled.ContainerButton>
        <Button
          onClick={handleSubmit(props.onSubmit, props.onError)}
          label={i18n.t('editProfile.edit')}
          disabled={props.loading}
          loading={props.loading}
        />
      </EditProfileFormStyled.ContainerButton>
    </EditProfileFormStyled.Container>
  );
};

export default EditProfileForm;
